import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExceptions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 21"
    {...props}
  >
    <path d="M3.32 3.596a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1zm4.169 5.117a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1z" />
    <path
      fillRule="evenodd"
      d="M13.18 15.33a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgExceptions;
